<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Anreise E-Mail

  section.modal-card-body
    ValidationObserver(ref="form")
      .generic-wrapper
        .container
          .two-column
            .column
            .column
              .form.w640
                h2.title.is-6 E-Mail schreiben
                ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Betreff" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.subject")
                ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Text" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    vue-editor(v-model="formData.body" :editorOptions="editorOptions")

      
  footer.modal-card-foot
    button.button.is-light(@click="$emit('close')") Abbrechen
    //- button.button.is-secondary(@click="sendArrival()") Speichern ohne Senden
    button.button.is-primary(@click="sendArrival('sendEmail')") Senden & Speichern
</template>

<script>
// import { DateTime } from "luxon";

export default {
  props: {
    booking: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      settings: null,
      formData: {
        subject: 'Bitte füllen Sie dieses Feld aus ...',
        body: null
      },
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  async mounted() {
    this.settings = await this.$store.dispatch("settings/find");
    this.fullBooking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
    const parentRentObject = await this.$store.dispatch("rentObjects/findOne", {id: this.fullBooking.rentObject.parentId});
    const emailTemplates = await this.$store.dispatch("emailTemplates/findAll");
    if (!this.settings.fallbackArrivalEmailTemplateId) {
      alert('Kontaktieren Sie Ihren Administrator. Es schein keine Standard-Vorlage für Anreise E-Mails hinterlegt worden zu sein.');
      this.$emit('close');
    }
    let fallbackTemplate = emailTemplates.find(e => e.id === this.settings.fallbackArrivalEmailTemplateId);
    if (!fallbackTemplate) {
      alert('Kontaktieren Sie Ihren Administrator. Die Standard-Vorlage für Anreise E-Mails konnte nicht gefunden werden.');
      this.$emit('close');
    }
    let parentTemplate = emailTemplates.find(e => e.id === (parentRentObject ? parentRentObject.emailTemplateId : -1));
    let rentObjectTemplate = emailTemplates.find(e => e.id === this.fullBooking.rentObject.emailTemplateId);
    const finalTemplate = rentObjectTemplate || parentTemplate || fallbackTemplate;

    const result = await this.$store.dispatch("emailTemplates/replaceTemplateValues", {template: finalTemplate, booking: this.fullBooking});
    this.formData.subject = result.template.subject;
    this.formData.body = result.template.body;
  },
  methods: {
    sendArrival(sendEmail) {
      this.$refs.form.validate().then(async success => {
        if (!success) {
          return;
        }

        const loadingComponent = this.$buefy.loading.open();
        await this.$store.dispatch("rentObjectBookings/sendArrivalEmail", {...this.formData, rentObjectBookingId: this.fullBooking.id, sendEmail});
        loadingComponent.close();

        this.$emit('refreshInbox');
        this.$emit('close');

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  justify-content: space-between;
}

.pdf-preview {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 280px);
}
</style>